"use client"

import { useEffect } from "react"
import MobileNav from "../../components/MobileNav"
import "./style.css"

export default function Home() {
  useEffect(() => {
    const elements = document.querySelectorAll("[data-animate]")
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible")
          }
        })
      },
      { threshold: 0.1 },
    )

    elements.forEach((el) => observer.observe(el))

    return () => {
      elements.forEach((el) => observer.unobserve(el))
    }
  }, [])

  return (
    <>
      <header className="light-header">
        <div className="container">
          <div className="logo">
            <a href="/" style={{ textDecoration: "none", color: "inherit", fontWeight: "bold" }}>
              Uniquely<span style={{ color: "var(--primary-color)" }}>Sharp</span>
            </a>
          </div>
          <nav className="desktop-nav">
            <a className="active" href="/">
              Home
            </a>
            <a href="/events">Events</a>
            <a href="/products">Products</a>
            <a href="/about">About Us</a>
            <a href="/contact">Contact</a>
          </nav>
          <MobileNav />
        </div>
      </header>

      <section
        className="hero-section"
        style={{
          backgroundImage: "url('../assets_task_01jr6hnvevf4bv810ajabzp1h7_img_0.webp')",
        }}
      >
        <div className="hero-content">
          <h1 data-animate="fade-down">Welcome to Uniquely Sharp</h1>
          <p data-animate="fade-up">Premium quality products for all your needs</p>
          <a href="/products" style={{ textDecoration: "none" }}>
            <button data-animate="zoom-in">VIEW OUR PRODUCTS</button>
          </a>
        </div>
        <div className="hero-overlay"></div>
      </section>

      <section className="featured">
        <div className="container">
          <div className="featured-header">
            <h2 data-animate="slide-right">Featured Products</h2>
            <a data-animate="slide-left" href="/products">
              View all →
            </a>
          </div>
          <div className="product-grid">
            {[
              {
                title: "Unforgotten Damascus",
                price: "$120",
                rating: "★★★★★",
                img: "/images/unforgotten damascus.jpg",
                description: "Overall Length 27 inches. Material Stainless Steel."
              },
              {
                title: "Zanpakuto Sword",
                price: "$110",
                rating: "★★★★★",
                img: "/images/Zanpakuto Sword.jpg",
                description: "Overall Length: 41 inches. Material Carbon Steel."
              },
              {
                title: "Demon Killer Sword",
                price: "$100",
                rating: "★★★★★",
                img: "/images/products5.jpg",
                description: "Overall Length 41 inches. Material Stainless Steel"
              },
            ].map((p, i) => (
              <div className="product-card" data-animate="fade-up" key={i}>
                <div className="product-image-container">
                  <img alt={p.title} className="product-image" src={p.img || "/placeholder.svg"} />
                  <div className="product-overlay">
                    <a href="/products" style={{ textDecoration: "none" }}>
                      <button className="view-details">View Details</button>
                    </a>
                  </div>
                </div>
                <div className="info">
                  <h3>{p.title}</h3>
                  <p className="product-description">{p.description}</p>
                  <div className="product-price">
                    <span className="price">{p.price}</span>
                    <span className="rating">{p.rating}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer-section">
        <div className="footer-content">
          <div className="footer-column">
            <h3>
              Uniquely<span>Sharp</span>
            </h3>
            <p>Premium quality knives and cutting tools for professionals and enthusiasts.</p>
            <div className="social-icons">
              <a href="https://www.facebook.com/share/g/15nBKAPV6a/?mibextid=wwXIfr" aria-label="Facebook">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon"
                >
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
              </a>
              <a href="https://www.instagram.com/uniquely_sharp" aria-label="Instagram">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon"
                >
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </a>
            </div>
          </div>

          <div className="footer-column">
            <h3>Company</h3>
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/events">Events</a>
              </li>
              <li>
                <a href="/products">Products</a>
              </li>
              <li>
                <a href="/about">About Us</a>
              </li>
              <li>
                <a href="/contact">Contact</a>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Contact</h3>
            <p>
            Bettendorf, Iowa
            </p>
            <p>
              UniquelySharpContact@gmail.com
              <br />
              (+1) 563-508-2716
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            © 2025 <strong>Uniquely Sharp</strong>. All rights reserved.
          </p>
        </div>
      </footer>
    </>
  )
}
